import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import AdminForm from '../Form';
import { fetchAdmin, updateAdmin } from '@resources/Admin/actions';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';

const Update = (props) => {
	const { fetchAdmin, admin, updateAdmin, visible, onCancel } = props;
	const intl = useIntl();

	useEffect(() => {
		const fetchData = async () => {
			await fetchAdmin(visible);
		};
		visible && fetchData();
	}, [fetchAdmin, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updateAdmin(admin._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.admin.update',
							defaultMessage:
								'An existing Admin entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[admin]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.admin',
					defaultMessage: 'Update Admin',
				})}
			</Title>
			{!isEmpty(admin) && (
				<AdminForm {...props} data={admin} onSubmit={handleSubmit} />
			)}
		</Modal>
	);
};

const mapStateToProps = ({
	admin,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
}) => {
	return {
		admin,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
	};
};

export default connect(mapStateToProps, {
	fetchAdmin,
	updateAdmin,
})(Update);
